var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[("bg-" + _vm.color), _vm.vertical ? 'h-100' : 'w-100'],style:(((_vm.vertical ? 'width:' : 'height:') + " " + (isNaN(_vm.size) ? _vm.size : (_vm.size + "px"))))})}
var staticRenderFns = []

export { render, staticRenderFns }